<template>
  <div
    class="relative min-h-[238px] bg-black/50 lg:min-h-[380px]"
    data-testid="services-hero"
  >
    <CommonImage
      :src="$cloudinary.resize(props.image, 'market-hero')"
      classes="absolute top-0 hidden h-full w-full object-cover object-center mix-blend-multiply filter lg:block"
      alt="desktop banner"
      data-testid="hero-image"
      fetch-priority="high"
    />
    <CommonImage
      :src="$cloudinary.resize(props.image, 'market-hero-mobile')"
      classes="absolute top-0 block h-full w-full object-cover object-center mix-blend-multiply filter lg:hidden"
      alt="mobile banner"
      fetch-priority="high"
    />

    <Breadcrumb
      :menu="breadcrumb ?? breadcrumbStore.items"
      class="absolute left-4 top-5 mb-6 text-white lg:left-big"
    />

    <div
      class="relative z-10 flex h-full w-full flex-col items-center justify-center p-5 px-small pb-12 pt-16 text-white lg:p-big lg:pb-20 lg:pt-28"
      :class="{ '!items-start': description }"
      data-testid="subscribe-call-to-action"
    >
      <div class="">
        <h3 class="text-2xl font-bold md:text-4xl text-center">
          {{ title }}
        </h3>

        <div v-if="description" class="mb-3 mt-4 max-w-[702px] text-lg">
          {{ description }}
        </div>
      </div>

      <div
        class="flex flex-row items-center justify-center gap-2 md:gap-4 w-full max-w-content-container flex-wrap gap-x-4"
        :class="{ 'mt-6': !description, 'lg:!justify-start': description }"
      >
        <GroupButtons
          :file="file"
          :initial-fields="initialFields"
          :download-text="downloadText"
          class="flex-wrap gap-x-4"
        >
          <slot name="extra-ctas" />
        </GroupButtons>
      </div>

      <div
        v-if="showSignIn && !loggedIn"
        class="mt-3 flex max-w-content-container items-center justify-center text-sm font-semibold"
        data-testid="hero-sign-in"
        :class="{ 'mx-auto lg:mx-0': description }"
      >
        Already a subscriber?
        <button
          class="ml-2 cursor-pointer underline decoration-1"
          @click="openModal('signIn')"
        >
          {{ signInText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
/** components */
import GroupButtons from '~/components/shared/services/GroupButtons.vue'
import Breadcrumb from '~/components/shared/navigation/Breadcrumb.vue'
import CommonImage from '~/src/components/common/images/CommonImage.vue'

/** stores */
import { useBreadcrumbStore } from '~/stores/breadcrumb'
import { useModalStore } from '~/stores/modal'

/** composables */
import useAuthentication from '~/composables/useAuthentication'

/** types */
import type { THero } from '~/src/types/common'

/** constants */
import { SIGN_IN } from '~/constants/services/constants'

/** props */
const props = withDefaults(defineProps<THero>(), {
  textAlign: 'center',
  downloadText: 'Methodology',
  showSignIn: true,
})

/** app */
const { open: openModal } = useModalStore()
const { loggedIn } = useAuthentication()
const breadcrumbStore = useBreadcrumbStore()
const { $cloudinary } = useNuxtApp()

/** vars/refs */
const signInText = SIGN_IN
</script>
